export const HEADER_CONTAINER = '.header__container';
export const MAIN_CONTENT_CONTAINER = '.main-content__container';
export const NAVIGATION_HEIGHT_MOBILE = 102;
export const NAVIGATION_HEIGHT_DESKTOP = 152;
export const NAVIGATION_HORIZONTAL = '.navigation-horizontal';
export const NAVIGATION_HORIZONTAL_COLLAPSE = 'navigation-horizontal--collapse';
export const LISTER_LAYOUT_ID = 'lister-layout';
export const WISHLIST_COMPONENT = '.wishlist-react';
export const RETURN_ITEMS_COMPONENT = '.return-items';
export const RETURN_PORTAL_GUEST_FORM_ERROR_FEEDBACK_ID = 'return-portal-guest-login__error-feedback';
export const LOGIN_FORM_ERROR_FEEDBACK_ID = 'login-form__error-feedback';
export const FORGOT_PASSWORD_SUCCESS_FEEDBACK_ID = 'forgot-password__success-feedback';
export const AUTH_POPUP_BUTTON_WRAPPER_ID = 'auth-popup-button';
export const BODY_WRAPPER_ID = 'body-wrapper';
